import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    standalone: false,
})
export class AlertComponent implements OnInit {
    public icon: string = null;

    public success: boolean = false;

    public warning: boolean = false;

    public error: boolean = false;

    public info: boolean = false;

    @Input()
    public width: 'auto' | 'full' = 'auto';

    @Input()
    public title: string;

    @Input()
    public set type(value: 'success' | 'warn' | 'error' | 'info') {
        this.success = value == 'success';
        this.warning = value == 'warn';
        this.error = value == 'error';
        this.info = value == 'info';

        switch (value) {
            case 'success':
                this.icon = 'heroicons_outline:check-circle';
                break;

            case 'warn':
                this.icon = 'warning';
                break;

            case 'error':
                this.icon = 'cancel';
                break;

            case 'info':
                this.icon = 'info';
                break;
        }
    }

    public constructor() {}

    public ngOnInit(): void {}
}
